module.exports = "<div class=\"_context-menu\">\n        <ul>\n            <li\n                    v-for=\"item in data\"\n                    :class=\"{disabled:item.disabled,divide:item.type=='divide','list-item':item.type!=='divide'}\"\n                    @click=\"click(item)\"\n            >\n                {{item.text}}\n            </li>\n        </ul>\n    </div>";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/context-menu.vue
 ** module id = 104
 ** module chunks = 0
 **/